import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from 'react-native';
import Modal from '@dbk/ui-modal';
import Text, { Large } from '../../../../../../src/components/common/text/index';
import Button from '@dbk/ui-buttons';
import styles from './termsconditions.styles';
import { Checkbox } from '@dbk/ui-forms';
import { ActionDetails, AlertDocName, AlertIds } from '../../../../../../src/components/alert-manager/alerts-map';
 
class TermsConditions extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      allError: '',
      showModal: true,
    }
 
    this.acceptCondition = this.acceptCondition.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.logOut = this.logOut.bind(this);
    this.clickSkipHandler = this.clickSkipHandler.bind(this);
    this.createTitle = this.createTitle.bind(this);
  }
 
  handleChange() {
    this.setState({ checked: !this.state.checked });
  }
 
  acceptCondition() {
    const { onNextActionClicked  } = this.props;
    const { checked } = this.state;
    onNextActionClicked();
 
    if (!checked) {
      // this.setState({ allError: messages['app.terms.allError'] });
      this.setState({ showModal: false });
      this.props.changePage('/dashboard')
   } else {
      this.setState({ allError: '' });
       const { alerts: { alertItems } } = this.props;
        const activeAlert = alertItems && alertItems.find(alert => alert.alertId === AlertIds.TNCP_POPUP)
        if(checked){
          activeAlert && this.props.setSeenStatus(activeAlert.alertId, ActionDetails.DO_NOT_SHOW, activeAlert?.metadata[0]?.alertDocId, activeAlert?.metadata[0]?.version);
          activeAlert && activeAlert.metadata.length>1 && this.props.setSeenStatus(activeAlert.alertId, ActionDetails.DO_NOT_SHOW, activeAlert?.metadata[1]?.alertDocId, activeAlert?.metadata[1]?.version);
        }
 
      this.setState({ showModal: false });
    }
  }
 
  logOut() {
    const { auth } = this.props;
    // this.setState({ showModal: false });
    auth.onLogout();
  }
  clickSkipHandler(){
    const { onNextActionClicked  } = this.props;
    onNextActionClicked();
    this.setState({ showModal: false });
    this.props.changePage('/dashboard')
  }
 
  componentWillMount() {
    this.props.languages.getlanguages();
   const { alerts: {alertItems}, } = this.props;
    const tncpAlert= alertItems && alertItems.find(alert => alert.alertId === AlertIds.TNCP_POPUP)
    this.setState({
      termsUrl: tncpAlert && tncpAlert.metadata.length && tncpAlert.metadata.find(alert => alert.alertDocName === AlertDocName.TNC)?.alertDocUrl,
      privacyUrl: tncpAlert && tncpAlert.metadata.length && tncpAlert.metadata.find(alert => alert.alertDocName === AlertDocName.PRIVACY)?.alertDocUrl,
    });
  }

  createTitle(url, urlName){
    const {i18n: { messages }} = this.props;
    return url ? url.split('/').pop().replace(/_/g, ' '): messages[urlName];
  }
 
  render() {
    const { i18n: { messages }, auth : { langCode }, languages: { destLanguage, destLanguageCode }, alerts: {alertItems}} = this.props;
    const { termsUrl, privacyUrl ,checked} = this.state;
    const remoteUrl = window.location.href.split('ebanking')[0] + '/ebankinguk';
    let termsLink = "";
    let privacyLink ="";
    let termsLinkForGerman = "";
    let privacyLinkForGerman ="";
    const termsTitle = this.createTitle(termsUrl,'app.terms.termsPdf');
    const privacyTitle = this.createTitle(privacyUrl,'app.terms.privacyPdf');

    termsLinkForGerman = remoteUrl + termsUrl;
    privacyLinkForGerman = remoteUrl + privacyUrl;
    termsLink = remoteUrl + termsUrl;
    privacyLink = remoteUrl + privacyUrl;
    
 
    const tncpAlert= alertItems && alertItems.find(alert => alert.alertId === AlertIds.TNCP_POPUP)
    const headline = tncpAlert?.title
 
    return (
      <Modal
        isActive={this.state.showModal}
        onClose={this.clickSkipHandler}
        header={headline}
        className="tnc-container"
        content={
          <div className="scene">
            <div className="row">
              {(termsUrl != null || privacyUrl != null) ?
                <div className="columns">
                   <div className='margin-left-13 margin-bottom-10'>
                    <Text> {tncpAlert?.content} </Text>
                  </div>
                  {/* <div className=" pad-bottom-20">
                    <Text>{messages['app.terms.downloadPdf']} </Text>
                  </div> */}
                  <div className="pad-bottom-20">
                     <ol className="tnc-list padding-left-30" >
                      {termsUrl && <li><a href={destLanguageCode == 'en-GB' ? termsLink : termsLinkForGerman} download={termsTitle} target="_blank"><Text style={styles.termsColor}> {messages['app.terms.termsPdf']}</Text></a></li>}
                      
                      {privacyUrl && <li><a href={destLanguageCode == 'en-GB' ? privacyLink : privacyLinkForGerman} download={privacyTitle} target="_blank" ><Text style={styles.termsColor}> {messages['app.terms.privacyPdf']}</Text></a></li>}
                    </ol>
                  </div>
                  <div className="termsCondition-main-wrapper">
                    <div className="center-content pad-top-10 margin-left-13">
                      <div id="chkbx_accept_termsConditions_test">
                        {/* <input title={messages['app.terms.agreement']} type='checkbox' checked={this.state.checked} onChange={(e) => this.handleChange(e)} /> */}
                         <Checkbox
                            title={messages['app.terms.agreement']}
                            onClick={(e) => this.handleChange(e)}
                            label={<Text>{messages['app.terms.agreement']}</Text>}
                            checked={checked}
                          />
                      </div>
                      {/* <View style={styles.checkRead} id="txt_termAgreement_termsConditions_test">
                        <Text>{messages['app.terms.agreement']}</Text>
                      </View> */}
                    </div>
                  </div>
                  <div className="text-center pad-top-20">
                    <Text style={styles.errorColor}>{this.state.allError}</Text>
                  </div>
                 <div className={`pad-top-10 margin-bottom-20`} style={{float:"inline-end"}}>
                    <Button testID="btn_acceptContinue_termsCondition_test" fullWidth size='normal' onPress={this.acceptCondition}>
                      {messages['app.terms.acceptContinue']}
                    </Button>
                  </div>
                </div>
                :
                <div className="columns small-12 small-centered medium-9 medium-centered large-8 large-centered">
                  <div className="text-center">
                    <Large>{messages['app.terms.linkError']}</Large>
                  </div>
                  <div className="small-6 small-centered pad-top-50">
                    <Button fullWidth size='normal' onPress={this.logOut}>
                      {messages['app.terms.logout']}
                    </Button>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      />
    );
  }
}
 
export default createContainer({
  $queries: {
    languages: {
      getlanguages: { $call: 'getlanguages' },
      destLanguage: true,
      destLanguageCode: true,
    },
    i18n: {
      messages: true,
    },
    auth: {
      userId: true,
      onLogout: { $call: 'logout' },
      langCode : true,
    },
    changePage: { $call: 'ui.history.push' },
     alerts: {
      alertItems: true,
    },
    setSeenStatus: { $call: 'alerts.seenStatus' },
  },
})(TermsConditions);